import { httpGet } from "@cirrus/core/http"
import { CustomerInfoService } from "../types"
import { FrontendConfig } from "../../FrontendConfig/types"

export class CustomerInfoServiceHttp implements CustomerInfoService {
	private customer: FrontendConfig["Customer"] | null = null

	getCustomerInfo = async () => httpGet(`/api/v1/customer/${this.customer}/info`)

	constructor(customer: FrontendConfig["Customer"]) {
		this.customer = customer
	}
}
